import { z } from 'zod'
import { isValidChineseIdCard } from '@/api/foreignPersonnel'
import { trimForValidate } from '@/utils/stringLength'

/** GB 11643-1999：18 位居民身份证号码 */
export const ID_CARD_LIMITS = {
  length: 18,
} as const

export const CN_ID_CARD_PATTERN = /^\d{17}[\dX]$/

function normalizeIdCardInput(value: unknown): string {
  return trimForValidate(value).toUpperCase()
}

/** 中国大陆 18 位身份证（必填，含校验位） */
export const cnIdCardSchema = z
  .string()
  .transform(normalizeIdCardInput)
  .pipe(
    z
      .string()
      .min(1, '请输入身份证号码')
      .length(ID_CARD_LIMITS.length, `身份证号码须为 ${ID_CARD_LIMITS.length} 位`)
      .regex(CN_ID_CARD_PATTERN, '身份证号码格式不正确')
      .refine(isValidChineseIdCard, '身份证号码校验位不正确'),
  )

/** 查询等场景：完整 18 位才校验格式 */
export const cnIdCardExactQuerySchema = z
  .string()
  .transform(normalizeIdCardInput)
  .pipe(
    z
      .string()
      .refine(
        (v) => !v || (v.length === ID_CARD_LIMITS.length && CN_ID_CARD_PATTERN.test(v)),
        `身份证号码须为 ${ID_CARD_LIMITS.length} 位`,
      )
      .refine((v) => !v || isValidChineseIdCard(v), '身份证号码格式不正确'),
  )
